import {IMucThuTuyenSinhSelectRequest} from "../../../model/request/chung-tu-tuyen-sinh/IMucThuTuyenSinhSelectRequest";
import {IProcessRequest} from "../../../model/request/IProcessRequest";
import {generateActionTypeIds} from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
import {IDataBIDV} from "./../../../model/respone/import/IDataBIDV";

export interface IThuPhiTuyenSinhTabActionTyes<T> {
    request: IMucThuTuyenSinhSelectRequest;
    data: T;
}

export const eImportTuyenSinhActionsObj = {
    IMPORT_BEGIN: undefined,

    IMPORT_START: {} as IProcessRequest<FormData>,
    IMPORT_SUCCESS: {} as IDataBIDV[],
    IMPORT_ERROR: "",

    SAVE_START: {} as IProcessRequest<IDataBIDV[]>,
    SAVE_SUCCESS: "",
    SAVE_ERROR: "",

    CLOSE_PROCESSING_MODAL: undefined,
};
export const eImportTuyenSinhActionIds = generateActionTypeIds(
    eImportTuyenSinhActionsObj,
    "IMPORT_TUYEN_SINH"
);
export type IImportTuyenSinhActionTypes = IGenericActionType<
    typeof eImportTuyenSinhActionsObj,
    "IMPORT_TUYEN_SINH"
>;
